module.exports = __webpack_public_path__ + "static/home_page-f7d5e6722ade8fcfd7defc00cad42366.png";